export enum SortBy {
  Relevance = 'RELEVANCE',
  Price = 'PRICE',
  DateCreated = 'DATE_CREATED',
  Mileage = 'MILEAGE',
  Year = 'YEAR',
}
